module.exports = __webpack_public_path__ + "static/piraciBg-dcf246f4c41d4781e5f5987267d1ac36.jpg";